<style lang="less" scoped>
    .type-picker{
        display: inline-block;
        width: 100%;
        vertical-align: middle;
        .ivu-poptip{
            width: 100%;
            /deep/ .ivu-poptip-rel{
                width: 100%;
            }
        }
    }
    .type{
        margin-bottom: 5px;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        border: 1px solid #dddee1;
        padding: 5px 8px;
        cursor: pointer;
        &:hover{
            background: #f5f5f5;
        }
    }
    .sub-types{
        padding-left: 8px;
        white-space: normal;
    }
</style>
<template>
  <div class="type-picker">
    <Poptip
      :disabled="disabled"
      transfer
      width="250"
      :placement="placement"
      @on-popper-show="popShow"
    >
      <div>
        <slot>请选择</slot>
      </div>
      <div slot="content">
        <i-input
          v-model="params.search"
          size="small"
          placeholder="搜索存货..."
        >
          <Button
            slot="append"
            icon="ios-search"
            :loading="loading"
            @click="search"
          />
        </i-input>
        <div class="hr" />
        <div
          v-for="type in select_types"
          :key="type.id"
          class="type"
          @click="select(type)"
        >
          <div>{{ type.full_name }}</div>
        </div>
      </div>
    </Poptip>
  </div>
</template>
<script>
  export default {
    props: {
      value: {
        type: String,
      },
      placement: {
        type: String,
        default: 'bottom-start'
      },
      disabled: {
        type:Boolean,
        default: false
      }
    },
    data() {
      return {
        params: {
          search: '',
        },
        types: [],
        loading: false
      }
    },
    computed: {
      select_types() {
        const search = this.params.search;
        if (!search) {
          return this.types;
        }
        return this.types.filter((type) => {return type.full_name.includes(search)});
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      popShow() {
        if (this.types.length === 0) {
          this.search();
        }
      },
      search() {
        this.loading = true;
        this.$util.ajax.get(this.$util.api.product_type_leaf_info, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.loading = false;
          this.types = [];
          if (res.code === 1) {
            const data = res.data;
            this.types = data.leaf_types;
            if (this.types.length === 0) {
              this.$Message.warning('未搜索到相关类目');
            }
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.loading = false;
          this.$Modal.error({
            title: '错误',
            content: e.message
          });
        });
      },
      select(type) {
        this.$emit('on-change', type);
        document.body.click();
      }
    }
  }
</script>
